import { useState, useEffect } from 'react';
import { getCustomColors } from '../services/colorPreferences';

export const useCustomColors = () => {
    const [colors, setColors] = useState(getCustomColors());

    useEffect(() => {
        const handleStorageChange = () => {
            setColors(getCustomColors());
        };

        // Listen for local event dispatch
        window.addEventListener('calendarColorsChanged', handleStorageChange);
        // Also listen for storage events (if changed in another tab)
        window.addEventListener('storage', handleStorageChange);

        return () => {
            window.removeEventListener('calendarColorsChanged', handleStorageChange);
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return colors;
};
